import { regex } from "../../utils/regexValidation";

const {
  email,
  mobileRegex,
  passwordRegex,
  facebookLinkRegex,
  twitterLinkRegex,
  instagramLinkRegex,
} = regex;

export const auth = {
  // Login Schema
  loginSchema: {
    number: {
      required: true,
      message: "Please provide phone number.",
      validate: (value, inputData = {}) => {
        return value.match(email) || value.match(mobileRegex);
      },
      invalidMessage: "Invalid  mobile number.",
      extraMessage: true,
    },
  },

  //   Sign Up Personal Info Form
  personalInfoSchema: {
    profile: {
      required: false,
      message: "Please provide your profile image",
    },
    fullName: {
      required: true,
      message: "Please provide name.",
    },
    nickname: {
      required: false,
      message: "Please provide your nickname.",
    },
    email: {
      required: true,
      message: "Please provide email.",
      validate: (value, inputData = {}) => {
        return value.match(email);
      },
      invalidMessage: "Invalid email.",
      extraMessage: true,
    },
    // number: {
    //   required: true,
    //   message: "Please provide phone number.",
    //   validate: (value, inputData = {}) => {
    //     return value.match(mobileRegex);
    //   },
    //   invalidMessage: "Invalid phone number.",
    //   extraMessage: true,
    // },
    dateOfBirth: {
      required: true,
      message: "Please provide your date of birth.",
    },
    gender: {
      required: true,
      message: "Please select your gender.",
    },
  },

  //   Sign Up Additional Info Form
  additionalInfoSchema: {
    profession: {
      required: false,
      message: "Please provide your profession",
    },
    country: {
      required: true,
      message: "Please provide your country",
    },
    state: {
      required: true,
      message: "Please provide your state",
    },
    city: {
      required: true,
      message: "Please provide your city",
    },
    whatsappNumber: {
      required: true,
      message: "Please provide phone number.",
      validate: (value, inputData = {}) => {
        return value.match(mobileRegex);
      },
      invalidMessage: "Invalid phone number.",
      extraMessage: true,
    },
    interestedCategories: {
      required: true,
      message: "Please select atleast one category.",
      validate: (value, inputData = {}) => {
        return value.length;
      },
      invalidMessage: "Please select atleast one category.",
      extraMessage: true,
    },
    // facebook: {
    //   required: false,
    //   message: "",
    //   validate: (value, inputData = {}) => {
    //     return value ? value.match(facebookLinkRegex) : false;
    //   },
    //   invalidMessage: "Invalid facebook link.",
    //   extraMessage: true,
    // },
    // instagram: {
    //   required: false,
    //   // message: "",
    //   validate: (value, inputData = {}) => {
    //     console.log(value, "Value");
    //     return value && value.match(instagramLinkRegex);
    //   },
    //   invalidMessage: "Invalid instagram link.",
    //   extraMessage: true,
    // },
    // x: {
    //   required: false,
    //   message: "",
    //   validate: (value, inputData = {}) => {
    //     return value ? value.match(twitterLinkRegex) : false;
    //   },
    //   invalidMessage: "Invalid X link.",
    //   extraMessage: true,
    // },
  },

  // Sign Up Schema
  signupSchema: {
    fullName: {
      required: true,
      message: "Please provide name.",
    },
    email: {
      required: true,
      message: "Please provide email.",
      validate: (value, inputData = {}) => {
        return value.match(email);
      },
      invalidMessage: "Invalid email.",
      extraMessage: true,
    },
    number: {
      required: true,
      message: "Please provide phone number.",
      validate: (value, inputData = {}) => {
        return value.match(mobileRegex);
      },
      invalidMessage: "Invalid phone number.",
      extraMessage: true,
    },
    dateOfBirth: {
      required: true,
      message: "Please provide your date of birth.",
    },
    gender: {
      required: true,
      message: "Please select your gender.",
    },
    city: {
      required: true,
      message: "Please provide your city.",
    },
    state: {
      required: true,
      message: "Please provide your state.",
    },
    country: {
      required: true,
      message: "Please provide your country.",
    },
    nickname: {
      required: true,
      message: "Please provide your nickname.",
    },
    profession: {
      required: true,
      message: "Please provide your profession.",
    },
    whatsappNumber: {
      required: true,
      message: "",
      validate: (value, inputData = {}) => {
        return inputData?.sameAsRegistered === "no";
      },
      invalidMessage: "Please provide your secondary number",
      extraMessage: true,
    },
  },

  // Forgot Password
  forgotPasswordSchema: {
    phone: {
      required: true,
      message: "Please provide  phone number.",
      validate: (value, inputData = {}) => {
        return value.match(email) || value.match(mobileRegex);
      },
      invalidMessage: "Invalid phone number.",
      extraMessage: true,
    },
  },

  // Question Stepper
  questionStepperSchema: {
    interest: {
      required: true,
      message: "",
      validate: (value, inputData = {}) => {
        return Array.isArray(value) && value.length > 0;
      },
      invalidMessage: "Please select atleast one.",
      extraMessage: true,
    },
    learning_goal: {
      required: true,
      message: "",
      validate: (value, inputData = {}) => {
        return Array.isArray(value) && value.length > 0;
      },
      invalidMessage: "Please select atleast one.",
      extraMessage: true,
    },
    time_dedication: {
      required: true,
      message: "Please select time",
    },
  },

  // Change Password Schema
  changePasswordSchema: {
    phone: {
      required: false,
    },
    newPassword: {
      required: true,
      message: "Please provide your new password.",
      validate: (value, inputData = {}) => {
        return value.match(passwordRegex);
      },
      invalidMessage:
        "Password should have at least 8 characters and contain uppercase letters, special characters, and numeric values.",
      extraMessage: true,
    },
    confirmPassword: {
      required: true,
      message: "Please provide your confirm password.",
      validate: (value, inputData) => {
        return value === inputData?.newPassword;
      },
      invalidMessage: "Confirm password does not match the new password.",
      extraMessage: true,
    },
  },
};
